 <template>
      <v-app>

    <core-toolbar></core-toolbar>
       <v-content>
        <v-card  max-width="900" class="mx-auto mt-5 pa-0" flat color="transparent">
            <v-toolbar flat color="transparent" v-if="Role('lead,supplier')">
              <!--v-btn icon @click="setPreview(true)">
                <v-icon>arrow_back</v-icon>
              </v-btn-->
              <v-toolbar-title>Algemene vragenlijst: {{settings.name}}</v-toolbar-title>
              <v-spacer></v-spacer>
             
              <v-btn icon v-if="false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <match-list v-if="Role('lead,supplier')" @select="load" @message="setMessage" :list="[selected]" :isMain="true" @preview="setPreview" :help="help" @download="download"></match-list>  
          
     
            <match-list v-if="preview"  @select="load" @message="setMessage"  @save="saveMatch" :list="list"></match-list>   

            <questionaire-edit  v-if="!preview" :max="5" :isMain="isMain" @save="save"></questionaire-edit> 
            <v-sheet  v-if="!preview" class="ma-5" color="transparent">
            <questionaire-add id="questionCard" loading="loading" @menu="tab='list'" @add="save"></questionaire-add> 
            <v-divider class="ml-4 mb-2"></v-divider>
                  
                    <questionaire-templates ref="templates" app="true"></questionaire-templates>
             <questionaire-list ref="qlist" :isMain="true" v-if="false">
               
              
          </questionaire-list>
          </v-sheet>
        </v-card>
        
          <!--questionaire-list ref="qlist" :isMain="isMain">
               <v-divider class="ml-4 mb-2"></v-divider>
                  
                    <questionaire-templates ref="templates" app="true"></questionaire-templates>
              
          </questionaire-list-->
    </v-content>
 <core-empty v-if="loading" icon="library_books" text="Vragenlijst" description="De vragenlijst wordt samengesteld en weergegeven."></core-empty>
   <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
     <v-snackbar
          v-model="snackbar"
          :bottom="true"
          color="success"
          :multi-line="true"
          :timeout="2000"
        >
          {{ snackbar_message }}
          <v-btn
            dark
            text
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>   
  </v-app>
</template>
<script>
import jsPDF from "jspdf";
import {
  mapActions,
  mapMutations,
  mapGetters,
  mapState
} from 'vuex'

 export default {
    props: [],
    data () {
      return {
          max: 5,
       loading: false,
       drawer: null,
      drawerRight: null,
      right: false,
      left: false,
      search: '',
      matchlist: []
      }
    },
    computed: {
    ...mapGetters('auth', ["Role"]),
      ...mapState('auth', ['authenticated',"settings"]),
      ...mapState('app', ["edit","footer","message","menu","preview","deeplink"]),
      ...mapState('match', ["selected"]),
      ...mapGetters('match', ["modified","suppliers"]),
      list () {
        return this.suppliers  
      },
       showMenu: {
          get() {
            return this.menu
          },
          set(value) {
            this.setMenu(value)
          }
        },
      company () {
        if (!this.settings.questions) this.settings.questions = []
        return {disabled: true,
                _id: this.settings._id,
                _lead: {
                      name: this.settings.name, 
                      logo: this.settings.relation.logo,
                      contacts: this.settings.contacts
                      },
                _supplier: {
                      name: "Uw vragenlijst", 
                      logo: this.settings.relation.logo,
                      contacts: this.settings.contacts
                      }, 
                  description: this.help,
                  questions: this.settings.questions,
                  answers: this.settings.answers || [],
                  tags: this.settings.tags,
                  _type: this.settings.role
        }
      },
      index () {
        return this.$router.currentRoute.params.index
      },
       redir () {
        return this.$router.currentRoute.params.redir
      },
     help (){
          if (!this.Role('lead')) return false
          if (this.isMain && this.preview) return this.$config.help.intro_question_laed_supplier
          return this.isEmpty ? this.$config.help.intro_question_laed_empty : this.$config.help.intro_question_laed
     },
     snackbar_message: {// getter
            get: function () {
              return this.message
            },
            // setter
            set: function (message) {
              this.setMessage(message)
            }
        },
     snackbar: {// getter
            get: function () {
              if (this.message!='') return true
              return false
            },
            // setter
            set: function (questions) {
              this.setMessage('')
            }
        },
      isMain () {
        if (this.selected._id!=this.settings._id && !this.readonly) return false
        return true
      },
      isEmpty () {
         if (!this.selected || !this.selected.questions) return true
         return this.selected.questions.length==0
      }
    },
    created () {
        this.setPreview(this.Role('admin,supplier'))
    },
     mounted () {
      
      this.showMenu=false
       //if (this.deeplink) this.loading = true
       var self = this
       this.resetRelation()
       this.setSelected(this.company)
       setTimeout(() => { self.loading = false}, 6000)
        this.$nextTick(() => {
          if (self.authenticated) {
            self.snackbar_message = "Welkom " + self.settings._user.name
            if (this.Role('admin,lead,supplier')) {
                self.load(true)
            }
          }
        })
      },
     watch: {
      /* (value,old) {
         if (!old && value) return this.save()
      },*/
      authenticated (value, old){

          if (value) this.loading = false
          if (!old && value && this.Role('admin,supplier')) {
              this.load(true)
          }
         this.setPreview(true)
        if (this.Role('lead')) this.setMenu(false)
      },
      preview (value, old) {
        if (!old && value) this.load()  
      },
      list (value){
          if (value.length > 0 ) this.loading = false
      }
    },
     methods : {
       ...mapMutations('app', ["setEdit","setTemplate", "setMenu", "setChat", "setMessage","setPreview"]),
       ...mapMutations('match', ["setSelected", "saveSelected", "updateSelected",'setSuppliers']),
       ...mapActions('match', ['getItem','saveItem', 'setList', 'getList']),
        ...mapActions('relation', ['updateRelation']),
        ...mapActions('auth', ['logout','login']),
        ...mapMutations('auth',['resetRelation']),
        
       /*load (settings){
          if (!settings || !settings._supplier) return this.doLogout()
         if (!settings.questions || settings.questions.length == 0) settings.questions =  this.settings.questions.slice(0)
          settings.questions = settings.questions.map(function(q){q.checks = q.checks|| []; return q })
         this.setSelected(settings)
         document.title = "NKC - Vragenlijst: " + settings._supplier.name;
         this.setMenu(true)
         
       },*/
       load(force) {
          if (force) this.setSuppliers({data: []})
          //if (this.list.length>0) return false
          if (this.loading || !this.settings._id) return false
          var self = this, rating
          self.loading =  true
          setTimeout(() => { self.loading = false}, 6000)
          //self.loading = (this.list.length == 0)

          var options = {item: {} , context:this.context, page_size: 100, ratingsource: 'track', q: this.search}
          options.rating = ['delivered', 'definitive']
          if (this.Role('lead')) options.source = 'match'
          if (this.Role('supplier')) options.source = 'supplier_matches'
          if (this.Role('lead,supplier')) options.index = this.settings._id,
          console.log('OPTIONS',options)
          options.next = function(response){
            console.log(response)
                  self.loading = false
                  self.setSuppliers(response)
                }
          this.getList(options)
        },
       save () {
          this.saveSelected(false)
           this.isMain ? this.saveSettings() : this.saveMatch()
       },
       saveSettings() {
        var self = this
        this.settings.questions = this.selected.questions
        this.settings.answers = this.selected.answers
        this.updateRelation({item: {_id: this.settings._id, questions: this.selected.questions, answers: this.selected.answers}, next: function(){
              self.loading = false
              self.snackbar_message = 'Instellingen zijn opgeslagen.'          
          }})
      },
    download() {
        const doc = new jsPDF();
        var self = this
        let rMargin = 10
        doc.setFont('helvetica')
        doc.setFontType('bold')
        doc.setLineWidth(0.1)
        doc.setDrawColor(200,200, 200) // draw red lines
        doc.setFontSize(22)
        doc.text(rMargin, 20, this.selected._supplier.name)
        doc.setFontType('normal')
        doc.setFontSize(10)
        var t = ''
        if (this.selected.event_date) t = this.timeStamp(this.selected.event_date) + ': '
        //t += this.mainContacts(this.selected).map(a => a.name).join(', ')
        doc.text(rMargin, 30, t)
        var line = 50 
        
        this.selected.questions.forEach(function(question, nr){
           doc.setFontSize(10)
           //doc.setFontType('bold')
          //+ (question.title.indexOf('?') == -1) ? '?' : ''
          doc.text(rMargin, line, (nr+1) + '. ' + question.title )
          doc.setFontType('normal')
          doc.setFontSize(9)
          if (question.description) {
            doc.text(rMargin, line+5, question.description )
          }
          var max = 6
          if (question.options) {
             question.options.forEach(function(Option,iii){
               var v = line*1+(10*iii) 
               doc.rect(rMargin, v + 3, 5, 5); 
               doc.text(rMargin+10, v+ 7, Option )
             })
          }
          for (var x = 0; x < max; x++) {
             line += 10
            doc.line(rMargin, line, 200, line)
          }
          line+=20
          if ([2,5,7,9].indexOf(nr) > -1 && self.selected.questions.length > nr+1) {
            doc.addPage()
            line = 20
          }
        })
        /*
         <b>{{timeStamp(selected.event_date)}}</b><span v-for="(contact) in mainContacts(selected)" :key="contact.name">, {{contact.name}}</span>
            <div class="print-question" v-for="(question, index) in questions" :key="index">
            
              <h3><b class="mr-2">{{index+1}}.</b> {{question.title}}{{questionMark(question)}}</h3>
              <p v-if="question.description" class="pb-2">{{question.description}}</p>
        
        */
        
        
        doc.output("dataurlnewwindow"); 
      },
      saveMatch(item){
         var self = this
         item = item || this.selected
        this.saveItem({item: {_id: item._id, questions: item.questions, answers: item.answers, score: item.score, description: item.description}, next: function(){
            self.loading = false
            self.snackbar_message = 'Vragenlijst is opgeslagen.'
          }})
      },
      doLogout() {
        this.logout()
        this.$router.push('/login')
      }
    },
     sockets: {
        online (user) {
          this.message = user.name + ' is online'
        },
        relation_update (upd){
            this.settings.questions = upd.questions
            this.updateSelected(upd)
            if (upd._user) self.snackbar_message  = upd._user.name + ' heeft de algemene vragenlijst aangepast'
        }
      }
  }
</script>
